// extracted by mini-css-extract-plugin
export var actions = "_4e-0";
export var actionsContainer = "_4e-7";
export var border = "_4e-1";
export var childFullHeight = "_4e-f";
export var collapse = "_4e-2";
export var content = "_4e-a";
export var contentChild = "_4e-e";
export var fullscreen = "_4e-c";
export var hasLeftRadius = "_4e-k";
export var headerContainer = "_4e-3";
export var headerRow = "_4e-5";
export var hidePadding = "_4e-b";
export var navCollapsedGap = "_4e-l";
export var noScrollX = "_4e-m";
export var noScrollY = "_4e-n";
export var noTopPadding = "_4e-i";
export var optOutTopPadding = "_4e-d";
export var pageMain = "_4e-j";
export var pageOuter = "_4e-g";
export var pagePadding = "_4e-8";
export var pageScroll = "_4e-9";
export var profile = "_4e-o";
export var profileContainer = "_4e-p";
export var profileImage = "_4e-q";
export var profileMain = "_4e-r";
export var profileSubtitle = "_4e-t";
export var profileTitle = "_4e-s";
export var showLeftPadding = "_4e-h";
export var tabsPortalSlot = "_4e-6";
export var tabsWrapper = "_4e-4";
export var title = "_4e-u";